import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, List, ListItem, Stack, Typography} from 'views/components';
import {VerifiedOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

import CardPaper from './CardPaper';

const RequirementsCard = (props) => {
  const {requirements} = props;
  const sections = [];

  if (requirements?.certifications?.length) {
    sections.push({
      key: 'certifications',
      title: translate('jobDetail.Requirements.LicenseCertification'),
      items: requirements.certifications.map((cert) => translate(`jobDetail.Requirements.CertificationsOptions.${cert}`)),
    });
  }

  if (requirements?.languages?.length) {
    sections.push({
      key: 'languages',
      title: translate('jobDetail.Requirements.RequiredLanguages'),
      items: requirements.languages.map((lang) => translate(`jobDetail.Requirements.LanguageOptions.${lang}`)),
    });
  }

  if (requirements?.considerations?.length) {
    sections.push({
      key: 'considerations',
      title: translate('jobDetail.Requirements.Considerations'),
      items: requirements.considerations.map((con) => translate(`jobDetail.Requirements.ConsiderationsOptions.${con}`)),
    });
  }

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <VerifiedOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.Requirements.Title' />
        </Typography>
      </Stack>

      {/* Only show the sections with dividers if it is not empty */}
      {
        sections.map((section, idx) => (
          <Box key={section.key} sx={{mb: idx === sections.length - 1 ? 0 : 1.5}}>
            <Typography variant="body2" sx={{fontWeight: 700, color: 'text.secondary', mb: 0.75}}>
              {section.title}
            </Typography>

            <List
              disablePadding
              sx={{
                m: 0,
                p: 0,
                listStyleType: 'disc',
                pl: 2.5,
              }}
            >
              {
                section.items.map((text, i) => (
                  <ListItem
                    key={i}
                    disableGutters
                    disablePadding
                    sx={{
                      display: 'list-item',
                      py: 0.15,
                      color: 'text.secondary',
                    }}
                  >
                    <Typography variant="body2" sx={{color: 'text.secondary'}}>
                      {text}
                    </Typography>
                  </ListItem>
                ))
              }
            </List>

            {idx < sections.length - 1 && <Divider sx={{my: 1.25}} />}
          </Box>
        ))
      }
    </CardPaper>
  );
};

RequirementsCard.propTypes = {
  requirements: PropTypes.object,
};

export default RequirementsCard;
